import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import { LocaleSwitcher } from "./LocaleSwitcher";

export const PublicNav = ({ testIdPrefix = "public" }) => {
  const { t } = useTranslation();
  return (
    <nav className="sticky top-0 z-50 border-b" style={{ background: "rgba(17,17,17,0.95)", backdropFilter: "blur(12px)", borderColor: "#252525" }}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid={`${testIdPrefix}-logo`}><Logo size="md" /></Link>
        <div className="flex items-center gap-3">
          <LocaleSwitcher />
          <Link to="/" data-testid={`${testIdPrefix}-back-btn`}
            className="flex items-center gap-2 text-sm transition-colors"
            style={{ color: "#6b6b6b" }}
            onMouseOver={e => e.currentTarget.style.color = "#c084fc"}
            onMouseOut={e => e.currentTarget.style.color = "#6b6b6b"}>
            <ArrowLeft className="w-4 h-4 rtl:rotate-180" /> {t("common.backToHome")}
          </Link>
        </div>
      </div>
    </nav>
  );
};
